import Container from '@mui/material/Container';
import { SettingsTabs } from '../features/settings';
import { PAGES_ANALYTICS_TITLES } from '../utils/enums';
import { PageHelmet } from '../components';

const SettingsPage = () => (
  <PageHelmet title={PAGES_ANALYTICS_TITLES.SETTINGS}>
    <Container
      sx={{
        px: { xs: 1, lg: 2 },
      }}
      maxWidth={false}
    >
      <SettingsTabs />
    </Container>
  </PageHelmet>
);

export default SettingsPage;
